import React from "react";
import ConnectedEmailsAddEditCard from "../../../../../components/Cards/ConnectedEmailsAddEditCard";
import {messagingSettingsStageEnum} from "../BaseMessagingSettingsPanel";

const EmailManagePanel = ({setStage, data}) => {
  const {email} = data;

  return (
    // TODO: Fix params like `handlePanel3Open`. Also complete the refactor of panel 3 from old UI.
    <ConnectedEmailsAddEditCard
      emailState={email}
      handlePanel3Open={(open) => {
        setStage({
          id: messagingSettingsStageEnum.settings,
          data: null,
        });
      }}
    />
  );
};

export default EmailManagePanel;
